import { z } from 'zod'
import type { VpnSetting } from '../../models/AppSetting'

export const VpnSettingDTO = z.object({
  terminal: z.string().nullish(),
  id: z.string().nullish(),
  cnpj_integrator: z.string().nullish(),
  cnpj_client: z.string().nullish(),
  ip: z.string().nullish(),
  otp: z.string().nullish()
})

export type VpnSettingDTO = z.infer<typeof VpnSettingDTO>

export function mapVpnSettingToDTO (model: VpnSetting): VpnSettingDTO {
  return {
    terminal: model.terminal,
    id: model.id,
    cnpj_integrator: model.cnpj_integrator,
    cnpj_client: model.cnpj_client,
    ip: model.ip,
    otp: model.otp
  }
}

export function mapDTOToVpnSetting (dto: VpnSettingDTO): VpnSetting {
  return {
    terminal: dto.terminal ?? undefined,
    id: dto.id ?? undefined,
    cnpj_integrator: dto.cnpj_integrator ?? undefined,
    cnpj_client: dto.cnpj_client ?? undefined,
    ip: dto.ip ?? undefined,
    otp: dto.otp ?? undefined
  }
}
